import FullscreenIcon from '@material-ui/icons/Fullscreen';
import ReplayIcon from '@material-ui/icons/Replay';
import * as React from 'react';

import { ChangeHistoryModal } from './ChangeHistoryModal';
import { useStyles } from './styles';

type ProductData = {
  id: number;
  title: string;
};

type ProductChangeHistoryProps = {
  productData: ProductData;
};

export const ProductChangeHistory = ({ productData }: ProductChangeHistoryProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const classes = useStyles();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div id='quickview-change-history' onClick={handleOpenModal} className={classes.changeHistoryButton}>
        <span className={classes.changeHistoryButtonTitle}>
          <ReplayIcon className={classes.changeHistoryButtonTitleIcon} /> Histórico de alterações
        </span>
        <FullscreenIcon className={classes.changeHistoryIcon} />
      </div>
      <ChangeHistoryModal isOpen={isModalOpen} handleClose={handleCloseModal} productData={productData} />
    </>
  );
};
